import type { SVGProps } from "react";
export const ArrowRightAlt = (props: SVGProps<SVGSVGElement>) => (
	<svg
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		aria-hidden={true}
		{...props}
	>
		<path
			d="M13.8462 17.6538L12.7923 16.5693L16.6115 12.75H4.5V11.25H16.6115L12.7923 7.43075L13.8462 6.34625L19.5 12L13.8462 17.6538Z"
			fill="currentColor"
		/>
	</svg>
);
